import axios from "axios";

const SHOPIFY_URL =
  "https://sym-machinery.myshopify.com/api/2025-07/graphql.json";

const STOREFRONT_TOKEN = "d84fafa8e04a8efb1473fe7cd2c51ddd";

const api = axios.create({
  baseURL: SHOPIFY_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
  },
});

export default api;